import { HttpErrorResponse } from "@angular/common/http";
import { Injectable, signal } from "@angular/core";
import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser";
import { TranslocoService } from "@ngneat/transloco";
import {
  DmsService,
  UpLoadProfileEnum,
} from "app/shared/common/utils/DmsService";
import { UtilComponent } from "app/shared/common/utils/UtilComponent";
import { ObjectAccessTokenService } from "app/shared/common/utils/token/ObjectAccessToken.service";
import { blobToDataURL } from "blob-util";
import PhotoSwipeLightbox from "photoswipe/lightbox";
import {
  BehaviorSubject,
  catchError,
  concatMap,
  from,
  of,
  switchMap,
  toArray,
} from "rxjs";
import { ActionStatus, IViewerConfig, IViewerHandler } from "./viewer.model";

@Injectable({ providedIn: "root" })
export class PhotoViewerService implements IViewerHandler {
  public loading = new BehaviorSubject<boolean>(false);
  public closeViewer$ = new BehaviorSubject<boolean>(false);

  listImages = signal([]);
  constructor(
    public dmsService: DmsService,
    public domSanitizer: DomSanitizer,
    public objectAccessTokenService: ObjectAccessTokenService,
    public utilComponent: UtilComponent,
    private translocoService: TranslocoService
  ) {}

  openViewer(input: Partial<IViewerConfig>, callback: () => void) {}

  public openViewerObs(input: Partial<IViewerConfig>, listData) {
    this.listImages.set([])
    this.loading.next(true);
    if(listData && listData.length > 0) {
      from(listData)
      .pipe(
        concatMap((item: any) => {
          return this.verifyAccessTokenObs(item.identifier, item.typeCode);
        }),
        toArray()
      )
      .subscribe((res) => {
        this._initPhotoSwipe(input.index);
      });
    }
    else{
      this.verifyAccessTokenObs(input.identifier, input.typeCode).subscribe(()=>this._initPhotoSwipe(input.index));
    }
    
  }

  private async _handleConfigureForImg(blobData: any) {
    const bmp = await createImageBitmap(blobData);
    const { width, height } = bmp;
    return { width, height };
  }
  private async _initPhotoSwipe(index) {
    const gallery = new PhotoSwipeLightbox({
      dataSource: this.listImages(),
      showHideAnimationType: "zoom",
      pswpModule: () => import("photoswipe"),
    });

    gallery.init();
    gallery.loadAndOpen(index);
    this.loading.next(false);
  }

  private _safeResourceUrl(blobData): SafeResourceUrl {
    const urlCreator = window.URL || window["webkitURL"];
    const imageSrc = urlCreator.createObjectURL(blobData);
    return this.domSanitizer.bypassSecurityTrustResourceUrl(imageSrc);
  }

  verifyAccessToken(
    identifier: string,
    callback: (status: ActionStatus) => void
  ) {}

  verifyAccessTokenObs(
    identifier: string,
    typeCode: UpLoadProfileEnum = UpLoadProfileEnum.CERTIFICATE
  ) {
    return this.dmsService
      .downloadAttachment(
        {
          identifier: identifier,
          type: typeCode,
        },
        "arraybuffer"
      )
      .pipe(
        switchMap((res) => {
          if (res === "blob") {
            return of(null);
          }
          return from(blobToDataURL(res)).pipe(
            switchMap(async (dataUrl) => {
              const { width, height } = await this._handleConfigureForImg(res);
              return {
                src: dataUrl,
                width: width || 512,
                height: height || 512,
              };
            })
          );
        }),
        switchMap((image) => {
          if (image) {
            const dataListImage = [...this.listImages(), image];
            this.listImages.set(dataListImage);
          }
          return of(image);
        }),
        catchError((err) => {
          if (err instanceof HttpErrorResponse && err.status == 403) {
            this.utilComponent.openSnackBarError(
              this.translocoService.translate(
                "DOCUMENT_LIST.YOU_DONT_HAVE_PERMISSION_TO_SEE_DOCUMENT"
              )
            );
          } else {
            this.utilComponent.openSnackBarError(
              this.translocoService.translate("FILE_NOT_FOUND")
            );
          }
          return of(null);
        })
      );
  }
}
